import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

function SimpleSvgIcon({ ...props }) {
  var { svgFile, color } = props;
  color = color || 'white';
  var divStyle = {
	backgroundColor: color,
	maskImage: 'url(' + svgFile + ')',
	WebkitMaskImage: 'url(' + svgFile + ')',
	width: '60px',
	height: '60px',
	WebkitMaskSize: '60px 60px'
  };
  return (
    <div style={divStyle}></div>
  );
}

SimpleSvgIcon.propTypes = {
  svgFile: PropTypes.string.isRequired,
  color: PropTypes.string
};

export default SimpleSvgIcon;



// WEBPACK FOOTER //
// ./src/components/Card/SimpleSvgIcon.jsx